import { useQueryClient, useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';
import * as api from '../../services/api';
import useAccount from '../account/useAccount';
import useConfetti from '../useConfetti';
import useToaster from '../useToaster';

const useBillingMethods = () => {
  const { push } = useHistory();
  const { accountId } = useAccount();
  const { setFire } = useConfetti();
  const { addResponseError } = useToaster();
  const queryClient = useQueryClient();

  const accountStoreKey = ['account', accountId];
  const accountConfigStoreKey = ['account-config', accountId];

  const { mutateAsync: addBillingMethod } = useMutation(
    (paymentPayload) => api.addBillingMethod({ accountId, body: paymentPayload }),
    {
      throwOnError: true,
      onSuccess: () => {
        queryClient.invalidateQueries(accountConfigStoreKey);
        queryClient.invalidateQueries(accountStoreKey);
        push(`/${accountId}`);
        setFire(true);
      },
      onError: (err) => {
        addResponseError(err);
      }
    }
  );

  return {
    addBillingMethod
  };
};

export default useBillingMethods;
